import * as React from 'react';
import { useEffect } from 'react';
import { MyPlotly } from '../MyPlotly';
import { makeCancelable } from './Utils';

interface IBPPlotlyProps {
    jsonUrl: string;
    title: string;
    width?: number;
    autoWidth?: boolean;
}

export const BPPlotly: React.FunctionComponent<IBPPlotlyProps> = (props) => {

    const [data, setData] = React.useState({ data: [], layout: {} })
    const config = { responsive: true };

    useEffect(() => {
        async function fetchData() {
            let response = await fetch(props.jsonUrl)
            let responseJson = await response.json()
            return responseJson;
        }

        let query = makeCancelable(fetchData())
        
        query.promise.then(value => setData(value));

        return () => {
            query.cancel();
        }
    }, []);


    return data.data.length > 0 ? <MyPlotly data={data.data} layout={data.layout} config={config} title={props.title} width={props.width} autoWidth={props.autoWidth} /> : <span></span>
};


